export const SHOW_ONBOARDING = 'SHOW_ONBOARDING';
export const HIDE_ONBOARDING = 'HIDE_ONBOARDING';
export const DISABLE_ONBOARDING = 'DISABLE_ONBOARDING';
export const SHOW_PERMISSION_PAGE = 'SHOW_PERMISSION_PAGE';
export const HIDE_PERMISSION_PAGE = 'HIDE_PERMISSION_PAGE';
